import React, { useState, useEffect } from 'react';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Button } from '@mui/material';

function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    setIsVisible(window.scrollY > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    isVisible && (
      <Button
        onClick={scrollToTop}
        startIcon={  <ArrowUpwardIcon sx={{ fontSize: '10!important', fontWeight: '800!important' }} />}
        style={{
          position: 'fixed',
          bottom: '3%',
          right: '.5%',
          backgroundColor: '#003366',
          fontWeight: 700,
          color: '#fff',
          border: '1px solid white',
          borderRadius: '20px',
          padding: '10px 20px',
          cursor: 'pointer',
          zIndex: 1000,
        }}
      >
        Back to Top
      </Button>
    )
  );
}

export default ScrollToTopButton;
